import { dealsWrapperRequestConstructor } from '@monorepo/deals';
import { DealService } from '@spilca/order_ts/v1/order_web/deal_web_pb_service';

const getDealsWrapper = (filter: object | null) =>
  dealsWrapperRequestConstructor(filter, DealService.ListDealWrapped);

export default getDealsWrapper;
